import { DependencyList, useEffect } from 'react';

const useDomEvent = (
  type: string,
  listener: (this: Document, ev: any) => any,
  dep: DependencyList | undefined,
) => {
  useEffect(() => {
    document.addEventListener(type, listener);

    return () => {
      document.removeEventListener(type, listener);
    };
  }, dep);
};

export default useDomEvent;
